import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import Layout from "./components/Layout";
import ScrollToTop from "./components/ScrollToTop";
import CookieConsent from "./components/CookieConsent";
import Home from "./pages/Home";
import Design from "./pages/Design";
import Connections from "./pages/Connections";
import Construction from "./pages/Construction";
import WaterConnections from "./pages/WaterConnections";
import ElectricalConnections from "./pages/ElectricalConnections";
import Metering from "./pages/Metering";
import Accreditations from "./pages/Accreditations";
import WhyChooseGreenFrog from "./pages/WhyChooseGreenFrog";
import GreenFrogGroup from "./pages/GreenFrogGroup";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Faq from "./pages/Faq";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import "./App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services/design" element={<Design />} />
            <Route path="/services/connections" element={<Connections />} />
            <Route path="/services/construction" element={<Construction />} />
            <Route path="/water-connections" element={<WaterConnections />} />
            <Route path="/electrical-connections" element={<ElectricalConnections />} />
            <Route path="/metering" element={<Metering />} />
            <Route path="/accreditations" element={<Accreditations />} />
            <Route path="/why-choose-green-frog" element={<WhyChooseGreenFrog />} />
            <Route path="/green-frog-group" element={<GreenFrogGroup />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cookies" element={<CookiePolicy />} />
          </Routes>
        </Layout>
        <CookieConsent />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
